module.exports = __webpack_public_path__ + "img/verde.058eaebd.svg";